import { useMemo } from "react";
import { Stack, Typography } from "@mui/material";

import WGRShopGroup from "./dwdGroup";
import WGRGrandTotal from "./dwdGrandTotal";
import WGRDemandTotal from "./WGRDemandTotal";





export default function WGRViewer({ rows, grandTotal, summary }) {

  const groupedData = useMemo(() => {
  const demandMap = {};

  rows.forEach((row) => {
    const demand =
      row.DispReportType?.trim() || "Unknown";

    const allocation =
      row.Allocation?.trim() || "Unknown";

    if (!demandMap[demand]) {
      demandMap[demand] = {
        allocations: {},
        total: {
          dl: 0,
          ds: 0,
          ocl: 0,
          ocs: 0,
          total: 0,
        },
      };
    }

    if (!demandMap[demand].allocations[allocation]) {
      demandMap[demand].allocations[allocation] = [];
    }

    demandMap[demand].allocations[allocation].push(row);

    // -------------------------
    // Demand Total
    // -------------------------

    const dl = Number(row["DIRECT LABOUR"] || 0);
    const ds = Number(row["DIRECT STORE"] || 0);
    const ocl = Number(row["ON COST LABOUR"] || 0);
    const ocs = Number(row["ON COST STORE"] || 0);

    const total = dl + ds + ocl + ocs;

    demandMap[demand].total.dl += dl;
    demandMap[demand].total.ds += ds;
    demandMap[demand].total.ocl += ocl;
    demandMap[demand].total.ocs += ocs;
    demandMap[demand].total.total += total;
  });

  return Object.keys(demandMap)
    .sort((a, b) => {
      const na = Number(a.match(/\d+/)?.[0] || 0);
      const nb = Number(b.match(/\d+/)?.[0] || 0);

      return na - nb;
    })
    .map((demand) => ({
      demand,

      allocations: Object.keys(
        demandMap[demand].allocations
      )
        .sort()
        .map((allocation) => ({
          allocation,
          rows: demandMap[demand].allocations[allocation],
        })),

      total: demandMap[demand].total,
    }));
}, [rows]);

 return (
  <Stack spacing={3}>

    {groupedData.map((demandGroup) => (

      <Stack
        key={demandGroup.demand}
        spacing={2}
      >

        {/* Demand Header */}

        <Typography
          variant="h5"
          fontWeight={700}
          sx={{
            mt: 2,
            px: 2,
            py: 1,
            bgcolor: "grey.800",
            color: "white",
            borderRadius: 1,
          }}
        >
          {demandGroup.demand}
        </Typography>


        {/* Allocation Groups */}

        {demandGroup.allocations.map(
          (allocationGroup) => (

            <WGRShopGroup
              key={`${demandGroup.demand}-${allocationGroup.allocation}`}
              allocation={allocationGroup.allocation}
              rows={allocationGroup.rows}
            />

          )
        )}


        {/* Demand / Report Type Total */}

        <WGRDemandTotal
          demand={demandGroup.demand}
          totals={demandGroup.total}
        />

      </Stack>

    ))}


    {/* Grand Total */}

    <WGRGrandTotal
      totals={grandTotal}
      summary={summary}
    />

  </Stack>
);
}